import React, { useState } from "react";
import { SaspButton } from "./SaspButton";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { NextPrevButton, ReviewSlider, CopyrightWidget, LabsComponent } from "../components";
import Popover from '@material-ui/core/Popover';
import { buttonStyles, cardStyles } from "../styles";
import "../styles/questionStyles.css";
import "../styles/masterStyles.css";
import { TextField, List, ListItem, ListItemIcon, Checkbox, FormControlLabel, FormGroup, Container, Divider, Grid, Button, Fab, Typography,} from "@material-ui/core";
import ModalImages from "../components/ModalImages";
import ModalWidget from "../components/ModalWidget";
import { remoteURL, scrollTop } from "../common";
import { isMobile, deviceDetect, deviceType, isElectron, isIOS, isAndroid } from 'react-device-detect';


//TODO restyle submit button. it's invisible when hidden right now

export const QuestionCard = props => {
    //TODO rename nextToggle and optionSelected. It's confusing as is. Disabled should be
    //toggleNext, and optionSelected should be disabled

    const classes = cardStyles();
    const buttons = buttonStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [value, setValue] = useState('');

    const handleFABClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleFABRemove = async () => {
        const removeCallBack = async (index) => {
            let obj = {
                mcid: props.question.mcid,
                key: props.myKey,
                deckID: props.deckID,
                questionid: props.question.questionID
            }

            if (isAndroid) {
                switch (index) {
                    case 1: {
                        return props.removeQuestion(obj);
                    }
                    default: {
                        return false;
                    }
                }
            } else if (isIOS) {
                switch (index) {
                    case 1: {
                        return props.removeQuestion(obj);
                    }
                    default: {
                        return false;
                    }
                }
            } else {
                switch (index) {
                    case 0: {
                        return props.removeQuestion(obj);
                    }
                    default: {
                        return false;
                    }
                }
            }
            
        }

        return navigator.notification.confirm(`Are you sure you want to remove Question ${props.question.questionNumber} from this deck?`, removeCallBack, 'Remove Question', ['Remove', 'Cancel']);
        
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    let [nextToggle, toggleNext] = useState(false);
    let [optionSelected, toggleOptionSelected] = useState(true);
    let [buttonOptions, toggleButtons] = useState({
        0: false,
        1: false,
        2: false,
        3: false,
        4: false
    });

    let [answerGrade, gradeAnswers] = useState({
        0: false,
        1: false,
        2: false,
        3: false,
        4: false
    });
    
    let [dynamicStyle, changeStyles] = useState({
        0: {
            trueClass: "questionButtons",
            trueColor: "trueQuestionButtons",
            falseColor: "questionButtons"
        },
        1: {
            trueClass: "questionButtons",
            trueColor: "trueQuestionButtons",
            falseColor: "questionButtons"
        },
        2: {
            trueClass: "questionButtons",
            trueColor: "trueQuestionButtons",
            falseColor: "questionButtons"
        },
        3: {
            trueClass: "questionButtons",
            trueColor: "trueQuestionButtons",
            falseColor: "questionButtons"
        },
        4: {
            trueClass: "questionButtons",
            trueColor: "trueQuestionButtons",
            falseColor: "questionButtons"
        }
    });

    const onSubmit = async(props, next) => {
        scrollTop('questionDiv', 0);
        await setValue('');
        let elem = document.getElementById('questioncomment-multiline-flexible');
        if (elem) {
            elem.classList.remove('active-text-field');
        }

        if (props.gameMode === 2 && 1 === 1) {
            for (let i = 0; i < Object.values(answerGrade).length; i++) {
                if (Object.values(buttonOptions)[i] === true) {
                    toggleButtons(old => {
                        let updated = false;
                        return { ...old, [i]: updated };
                    });
                    props.updateOption(props.answers[i].AnswerOptionID);
                }
            }

            if (!optionSelected) {
                toggleOptionSelected(false);
            }

            toggleNext((nextToggle = false));
            return props.goNext(true);
        } else if (props.gameMode !== 2 && next === true ) {
            for (let i = 0; i < Object.values(answerGrade).length; i++) {
                toggleButtons(old => {
                    let updated = false;
                    return { ...old, [i]: updated };
                });
                changeStyles(old => {
                    let updated = {
                        trueClass: "questionButtons",
                        trueColor: "trueQuestionButtons",
                        falseColor: "questionButtons"
                    };
                    return { ...old, [i]: updated };
                });
                gradeAnswers(old => {
                    let updated = false;
                    return { ...old, [i]: updated };
                });

                if (!optionSelected) {
                    toggleOptionSelected(true);
                }
            }

            goNext();

            return toggleNext((nextToggle = false));
        } else {
            for (let i = 0; i < Object.values(answerGrade).length; i++) {
                if (Object.keys(buttonOptions)[i] === i) {
                    if (props.answers[i].AnswerOptionCorrect === 1) {
                        gradeAnswers(old => {
                            let updated = "check";
                            return { ...old, [i]: updated };
                        });
                        changeStyles(old => {
                            let updated = {
                                trueClass: "correctGradedButtons",
                                trueColor: "correctQuestionButtons",
                                falseColor: "correctGradedButtons"
                            };
                            return { ...old, [i]: updated };
                        });
                        if (Object.values(buttonOptions)[i] === true) {
                            toggleButtons(old => {
                                let updated = false;
                                return { ...old, [i]: updated };
                            });
                        } else {
                            toggleButtons(old => {
                                let updated = true;
                                return { ...old, [i]: updated };
                            });
                        }
                    }
                    if (Object.values(buttonOptions)[i] === true) {
                        props.updateOption(props.answers[i].AnswerOptionID);
                        if (props.answers[i].AnswerOptionCorrect === 0) {
                            gradeAnswers(old => {
                                let updated = "wrong";
                                return { ...old, [i]: updated };
                            });
                            changeStyles(old => {
                                let updated = {
                                    trueClass: "incorrectGradedButtons",
                                    trueColor: "incorrectQuestionButtons",
                                    falseColor: "incorrectGradedButtons"
                                };
                                return { ...old, [i]: updated };
                            });
                            toggleButtons(old => {
                                let updated = false;
                                return { ...old, [i]: updated };
                            });
                        }
                    }
                }
            }
            toggleNext((nextToggle = !nextToggle));
        }
    };

    const handleClick = index => {
        for (let i = 0; i < Object.values(buttonOptions).length; i++) {
            if (index === i && buttonOptions[i] !== true) {
                toggleButtons(old => {
                    let updated = true;
                    return { ...old, [index]: updated };
                });
            } else {
                toggleButtons(old => {
                    let updated = false;
                    return { ...old, [i]: updated };
                });
            }
        }
        if (optionSelected === true) {
            toggleOptionSelected(false);
        }
    };

    const renderQuestions = props => {
        if (props.answers) {
            return props.answers.map((item, index) => {
                let gridClass = classes.questionButtonsContainer;
                if (nextToggle && !answerGrade[index]) {
                    gridClass = 'hidden';
                }
                return (
                    <Grid
                        style={{ padding: "10px", minHeight: "4em" }}
                        className={gridClass}
                        item
                        xs={12}
                    >
                        <SaspButton
                            endIcon={answerGrade[index]}
                            key={item.AnswerOptionID}
                            trueClass={dynamicStyle[index].trueClass}
                            trueColor={dynamicStyle[index].trueColor}
                            falseColor={dynamicStyle[index].falseColor}
                            onClick={() => handleClick(index)}
                            selected={buttonOptions[index]}
                            button="DynamicButton"
                            disabled={nextToggle}
                            style={{ height: "100%", justifyContent: "flex-start" }}
                        >
                            {/* TODO EDIT this typography to match better */}
                            <div>{item.AnswerOptionLetter}.</div>
                            <div className="margin-left-16" dangerouslySetInnerHTML={createMarkup(item.AnswerOption)}></div>
                        </SaspButton>
                    </Grid>
                );
            });
        } else {
            return (
                <>
                    <Grid className={classes.answerButtons} item xs={12}>
                        <SaspButton
                            button="DynamicButton"
                            onClick={() => handleClick(0)}
                            selected={buttonOptions[0]}
                        >
                            Choice 1
                        </SaspButton>
                    </Grid>
                    <Grid className={classes.answerButtons} item xs={12}>
                        <SaspButton
                            button="DynamicButton"
                            onClick={() => handleClick(1)}
                            selected={buttonOptions[1]}
                        >
                            Choice 2
                        </SaspButton>
                    </Grid>
                    <Grid className={classes.answerButtons} item xs={12}>
                        <SaspButton
                            button="DynamicButton"
                            onClick={() => handleClick(2)}
                            selected={buttonOptions[2]}
                        >
                            Choice 3
                        </SaspButton>
                    </Grid>
                    <Grid className={classes.answerButtons} item xs={12}>
                        <SaspButton
                            button="DynamicButton"
                            onClick={() => handleClick(3)}
                            selected={buttonOptions[3]}
                        >
                            Choice 4
                        </SaspButton>
                    </Grid>
                    <Grid className={classes.answerButtons} item xs={12}>
                        <SaspButton
                            button="DynamicButton"
                            onClick={() => handleClick(4)}
                            selected={buttonOptions[4]}
                        >
                            Choice 5
                        </SaspButton>
                    </Grid>
                </>
            );
        }
    };

    const goToQuestion = async (id, type) => {
        scrollTop('questionDiv', 0);
        
        for (let i = 0; i < Object.values(buttonOptions).length; i++) {
            await toggleButtons(old => {
                let updated = false;
                return { ...old, [i]: updated };
            });
            
            await changeStyles(old => {
                let style = {
                    trueClass: "questionButtons",
                    trueColor: "trueQuestionButtons",
                    falseColor: "questionButtons"
                };
                return { ...old, [i]: style };
            });
        }
        
        await setValue('');
        await toggleNext(false);
        props.skipQuestion(id, type);
    }

    const goNext = async () => {
        scrollTop('questionDiv', 0);
        
        for (let i = 0; i < Object.values(buttonOptions).length; i++) {
            await toggleButtons(old => {
                let updated = false;
                return { ...old, [i]: updated };
            });

            await gradeAnswers(old => {
                let updated = false;
                return { ...old, [i]: updated };
            });
            
            await changeStyles(old => {
                let style = {
                    trueClass: "questionButtons",
                    trueColor: "trueQuestionButtons",
                    falseColor: "questionButtons"
                };
                return { ...old, [i]: style };
            });
        }
        
        await setValue('');
        await toggleNext(false);

        props.goNext()
    }

    const addQuestion = async (obj) => {
        if (obj.send) {
            await props.addToDecks(obj.questionID, obj.deckID);
            if (obj.id) {
                let element = document.getElementById(obj.id);
                if (element) {
                    try {
                        element.className = "hidden"
                    } catch (e) {
                    }
                }
            }
        }
    }

    const createMarkup = props => {
        return { __html: props };
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleBlur = async (event) => {
        let obj = {
            mcid: props.question.mcid,
            key: props.myKey,
            comment: value,
            gameMode: Number(props.gameMode),
            questionID: props.question.questionID
        }

        switch(Number(props.gameMode)) {
            case 1:
            case 2: {
                obj.yearvar = props.question.availableyears;
                break;
            }

            case 3:
            case 4: {
                obj.deckID = props.deckID;
                break;
            }
        }

        let elem = document.getElementById('questioncomment-multiline-flexible');
        if (elem) {
            elem.classList.add('active-text-field');
        }
        await props.addNote(obj);
    }

    let temp = props.deckList.find(item => item.deckID === props.deckID);
    let owner = 0;
    if (typeof temp !== 'undefined') {
        owner = Number(temp.owner);
    } 

    let questionName = props.gameMode < 3 ? 'Question ' +  props.question.questionNumber : props.deckText;
    let referenceURI = 'https://university.auanet.org/mobileapps/sasp/resources/references.cfm?questionid=' + props.question.questionID + '&questionnumber=' + props.question.questionNumber + '&id=' + props.question.mcid + '&key=' + props.myKey;

    let isspaced = null;
    let _thisdeck = props.deckList.filter(item => item.deckID === props.deckID);

    if (_thisdeck.length > 0) {
        isspaced = _thisdeck[0].isspaced;
    }

    return (
        <Container
            disableGutters={props.disableGutters || false}
            fixed={props.fixed || false}

            className={classes.questionContainer}
            style={{maxWidth: "calc(100% - 32px)", padding: "16px"}}
        >
            <div 
                style={{
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent:"space-between",
                    marginTop: "24px"
                }}
            >
                <div className="text-strong margin-left-20">
                    {questionName}
                </div>

                {props.gameMode < 3 || owner
                    ? (
                        <div>
                            <>
                                {owner
                                    ? (
                                        <Fab
                                            size="small"
                                            style={{backgroundColor: "#97A19C", color: '#fff', marginRight: "8px"}}
                                            aria-label="remove"
                                            onClick={() => handleFABRemove()}
                                            InDecks={props.question.InDecks}
                                        >
                                            <RemoveIcon className="text-white"/>
                                        </Fab>
                                    ) : null
                                }
                            </>
                            <Fab
                                size="small"
                                style={{backgroundColor: props.cardColor, color: '#fff'}}
                                aria-label="add"
                                onClick={handleFABClick}
                                InDecks={props.question.InDecks}
                            >
                                <AddIcon className="text-white"/>
                            </Fab>
                            <Popover
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                <List dense={true}>
                                    <ListItem>
                                        <FormGroup row>
                                            <FormControlLabel 
                                                control={
                                                    <Checkbox 
                                                        onChange={(event) => addQuestion({
                                                            questionID: props.question.questionID, 
                                                            gameMode: props.question.gameMode,
                                                            deckID: null,
                                                            send: event.target.checked
                                                        })}
                                                    />
                                                }
                                                label="Add to All Decks"
                                            />
                                            
                                        </FormGroup>
                                    </ListItem>
                                    <Divider />

                                    {props.deckList.map((row, index) => (
                                        <ListItem id={"FABList_" + row.deckID}>
                                            <FormGroup row>
                                                <FormControlLabel 
                                                    control={
                                                        <Checkbox 
                                                            onChange={(event) => addQuestion({
                                                                gameMode: props.question.gameMode, 
                                                                deckID: row.deckID,
                                                                questionID: props.question.questionID,
                                                                send: event.target.checked,
                                                                id:"FABList_" + row.deckID
                                                            })}
                                                            className='text-grey'
                                                            checked={(props.question.InDecks.includes(row.deckID)) ? true : false}
                                                        />
                                                    }
                                                    label={row.deckname.length ? row.deckname : `My Deck ${index}`}
                                                />
                                            </FormGroup>
                                        </ListItem>
                                    ))}
                                </List>
                            </Popover>

                            <LabsComponent labs={props.labs}/>
                        </div>
                    )
                    : (
                        <div>
                            <Fab
                                size="small"
                                style={{backgroundColor: "#97A19C", color: '#fff'}}
                                aria-label="remove"
                                onClick={() => handleFABRemove()}
                                InDecks={props.question.InDecks}
                            >
                                <RemoveIcon className="text-white"/>
                            </Fab>

                            <LabsComponent labs={props.labs}/>
                        </div>
                    )
                }
            </div>

            <div
                className="questionStem"
                dangerouslySetInnerHTML={createMarkup(props.question.questionText)}
            />

            <div>
                { props.question.qImages.length > 0
                    ? (
                        <ModalImages 
                            qImages={props.question.qImages}
                            title={(props.gameMode < 3) ? 'Question ' + props.question.questionNumber : props.deckText }
                            backgroundColor={props.cardColor}
                            color={props.cardColor}
                        />
                    )
                    : null
                }
            </div>

            <Grid
                container={props.gridContainer || true}
                className={classes.questionTextContainer}
                alignContent={props.alignGrid || "stretch"}
                alignItems={props.alignGridItems || "stretch"}
                direction={props.gridDirection || "row"}
                item={props.gridItems || false}
                justify={props.justifyGrid || "flex-start"}
                lg={props.gridLG || false}
                md={props.gridMD || false}
                sm={props.gridSM || false}
                spacing={props.gridSpacing || 0}
                wrap={props.gridWrap || "wrap"}
                xl={props.gridXL || false}
                xs={props.gridXS || false}
                zeroMinWidth={props.gridZeroMinWidth || false}
            >
                {renderQuestions(props)}
            </Grid>

            <Divider style={{ marginBottom: "24px" }} className="SASPQuestionDivider" />

            <div
                style={{
                    paddingTop: "16px",
                    paddingBottom: "24px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                {props.prevID != '0'
                    && props.prevID != null
                    && props.gameMode < 3
                    ? (
                        <NextPrevButton 
                            gameMode={props.gameMode}
                            refresh={false}
                            next={false}
                            prev={true}
                            backgroundColor={props.cardColor}
                            nextID={props.nextID}
                            prevID={props.prevID}
                            func={() => goToQuestion(props.prevID, 'prev')}
                        />
                    )
                    : (
                        <NextPrevButton 
                            gameMode={props.gameMode}
                            refresh={false}
                            next={false}
                            prev={false}
                            backgroundColor={props.cardColor}
                            nextID={props.nextID}
                            prevID={props.prevID}
                            func={() => {return false}}
                        />
                    )
                }

                {!nextToggle ? (
                    optionSelected ? (
                        <SaspButton
                            disabled={true}
                            className="SubmitButtons"
                            color="submitButtons"
                        >
                            Submit
                        </SaspButton>
                    ) : (
                        <>
                            {props.gameMode === 2 || props.gameMode === 4
                                ? (
                                    <SaspButton
                                        className="SubmitButtons"
                                        color="questionButtons"
                                        onClick={() => onSubmit(props, true)}
                                    >
                                        Submit
                                    </SaspButton>
                                )
                                : (
                                    <SaspButton
                                        className="SubmitButtons"
                                        color="submitButtons"
                                        onClick={() => onSubmit(props, false)}
                                    >
                                        Submit
                                    </SaspButton>
                                )
                            }
                        </>
                    )
                ) : (
                    <SaspButton
                        className="SubmitButtons"
                        color="questionButtons"
                        onClick={() => onSubmit(props, true)}
                    >
                        Next
                    </SaspButton>
                )}

                {props.nextID != '0' 
                    && props.gameMode < 3
                    && props.prevID != null
                    ? (
                        <NextPrevButton 
                            gameMode={props.gameMode}
                            refresh={false}
                            next={true}
                            prev={false}
                            backgroundColor={props.cardColor}
                            nextID={props.nextID}
                            prevID={props.prevID}
                            func={() => goToQuestion(props.nextID, 'next')}
                        />
                    )
                    : (
                        <NextPrevButton 
                            gameMode={props.gameMode}
                            refresh={true}
                            next={false}
                            prev={false}
                            backgroundColor={props.cardColor}
                            nextID={props.nextID}
                            prevID={props.prevID}
                            func={() => goNext()}
                        />
                    )
                }
            </div>

            {typeof props.refsMats !== 'undefined' && props.refsMats
                ? (
                    <div
                        style={{
                            paddingBottom: "24px",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <ModalWidget 
                            text={`Show Reference Materials`}
                            title={`SASP ${props.question.QuestionYear} Reference Materials`}
                            color={'#00567a'}
                            body={props.refsMats}
                        />
                    </div>
                ) : null
            }

            {nextToggle
            ? (
                <>
                    <Grid
                        container={props.gridContainer || true}
                        className={classes.questionTextContainer}
                        alignContent={props.alignGrid || "stretch"}
                        alignItems={props.alignGridItems || "stretch"}
                        direction={props.gridDirection || "row"}
                        item={props.gridItems || false}
                        justify={props.justifyGrid || "flex-start"}
                        lg={props.gridLG || false}
                        md={props.gridMD || false}
                        sm={props.gridSM || false}
                        spacing={props.gridSpacing || 0}
                        wrap={props.gridWrap || "wrap"}
                        xl={props.gridXL || false}
                        xs={props.gridXS || false}
                        zeroMinWidth={props.gridZeroMinWidth || false}
                    >
                        <Grid xs={12} item>
                            <Typography className="DividerText padding-right-8">
                                Add Note
                            </Typography>
                            <Divider className="SASPDivider padding-left-8 padding-right-8" />
                        </Grid>
                        <Grid item xs={12} className="margin-bottom-24">
                            <form noValidate autoComplete="off">
                                <TextField
                                    id="questioncomment-multiline-flexible"
                                    label=""
                                    multiline
                                    rowsMax={10}
                                    rows={3}
                                    value={value}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="width100"
                                />
                            </form>
                        </Grid>
                    </Grid>

                    <Grid
                        container={props.gridContainer || true}
                        className={classes.questionTextContainer}
                        alignContent={props.alignGrid || "stretch"}
                        alignItems={props.alignGridItems || "stretch"}
                        direction={props.gridDirection || "row"}
                        item={props.gridItems || false}
                        justify={props.justifyGrid || "flex-start"}
                        lg={props.gridLG || false}
                        md={props.gridMD || false}
                        sm={props.gridSM || false}
                        spacing={props.gridSpacing || 0}
                        wrap={props.gridWrap || "wrap"}
                        xl={props.gridXL || false}
                        xs={props.gridXS || false}
                        zeroMinWidth={props.gridZeroMinWidth || false}
                    >
                        {isspaced 
                            ? (
                                <Grid item xs={12}>
                                    <ReviewSlider 
                                        gameMode={props.question.gameMode}
                                        questionID={props.question.questionID}
                                        deckID={props.deckID}
                                        mcid={props.question.mcid}
                                        myKey={props.myKey}
                                        putNextReviewDate={props.putNextReviewDate}
                                    />
                                    <br />
                                </Grid>
                            ) : null
                        }

                        {props.explanation.questionExplanation 
                            ? (
                                <Grid item xs={12}>
                                    <Typography 
                                        className="DividerText anchor"
                                    >
                                        Explanation
                                    </Typography>
                                    <Divider className="SASPDivider" />
                                    <div
                                        style={{ lineHeight: "1.6em" }}
                                        dangerouslySetInnerHTML={createMarkup(
                                            props.explanation.questionExplanation
                                        )}
                                    />
                                    <br />

                                    <Typography className="DividerText anchor">
                                        References
                                        <div
                                            style={{
                                                position:"absolute",
                                                right: "0",
                                                top: "8px",
                                                display:"flex",
                                                flexDirection:"column",
                                                justifyContent:"center",
                                                alignItems:"center"
                                            }}
                                        >
                                            <a 
                                                onClick={() => remoteURL(referenceURI)}
                                            >
                                                <ExitToAppIcon className="text-blue" />
                                            </a>
                                        </div>
                                    </Typography>
                                    <Divider className="SASPDivider" />
                                    <div
                                        style={{ lineHeight: "1.6em" }}
                                        dangerouslySetInnerHTML={createMarkup(
                                            props.explanation.questionReference
                                        )}
                                    />
                                </Grid>
                            ) 
                            : (
                                <Grid item xs={12}>
                                    <Typography>
                                        Sorry, we are having trouble fetching the explanation for this
                                        question.
                                    </Typography>
                                </Grid>
                            )
                        }
                    </Grid>
                </>
            ) : null}
        </Container>
    );
};